import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      ligth: '#00aeca',
      main: '#00aeca',
      dark: '#00aeca',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#90a4ae'
    }
  }
});

export default theme;
